import http from "./http";

/**
 * دریافت لیست فروشگاه‌های فعال با فیلتر و سرچ
 * @param {Object} params - { store_type, province, city, search }
 */
export const fetchPublicStores = async (params = {}) => {
  const filtered = Object.fromEntries(
    Object.entries(params).filter(
      ([, v]) => v !== "" && v !== null && v !== undefined,
    ),
  );
  const response = await http.get("/stores/public/stores/", {
    params: filtered,
  });
  return response.data;
};

/**
 * دریافت گزینه‌های فیلتر (استان، شهر، دسته‌بندی)
 */
export const fetchFilterOptions = async () => {
  const response = await http.get("/stores/public/filter-options/");
  return response.data;
};

export const getLatestStores = () => {
  return http.get("stores/public/latest-stores/");
};

export const getProducts = (
  search,
  city,
  province,
  store_category,
  min_price,
  max_price,
  page,
  page_size,
) => {
  return http.get("/store-management/website/products", {
    params: {
      search,
      city,
      province,
      store_category,
      min_price,
      max_price,
      page,
      page_size,
    },
  });
};
